module.exports = __webpack_public_path__ + "fronted/src/img/voice1.9d8bd351.png";